import React from "react";

const EmploymentPagination = ({ pagination, onPrevious, onNext }) => {
  if (!pagination || pagination.totalItems <= 0) {
    return null;
  }

  const startItem = ((pagination.page - 1) * pagination.pageSize) + 1;
  const endItem = Math.min(pagination.page * pagination.pageSize, pagination.totalItems);

  return (
    <div className="mt-3 flex items-center justify-between rounded-xl border border-slate-200 bg-white px-5 py-3">
      <p className="text-xs text-slate-500">
        Showing{" "}
        <span className="font-medium text-slate-700">{startItem}</span>
        {" - "}
        <span className="font-medium text-slate-700">{endItem}</span>
        {" of "}
        <span className="font-medium text-slate-700">{pagination.totalItems}</span>
      </p>

      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={pagination.page <= 1}
          onClick={onPrevious}
          className="
            rounded-lg
            border
            border-slate-200
            px-3
            py-1.5
            text-xs
            font-medium
            text-slate-600
            transition
            hover:bg-slate-50
            disabled:cursor-not-allowed
            disabled:opacity-40
          "
        >
          Previous
        </button>

        <span className="min-w-[70px] text-center text-xs text-slate-500">
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          type="button"
          disabled={pagination.page >= pagination.totalPages}
          onClick={onNext}
          className="
            rounded-lg
            border
            border-slate-200
            px-3
            py-1.5
            text-xs
            font-medium
            text-slate-600
            transition
            hover:bg-slate-50
            disabled:cursor-not-allowed
            disabled:opacity-40
          "
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default EmploymentPagination;
